enum ProductStatus {
  ACTIVE = 'ACTIVE',
  ALL = 'ALL',
}

export default ProductStatus;
